
/*
Diese Funktion fragt ab, ob wir auf der Seite "products" sind, um lädt dann die Warenbestandsanzeige 
für das Product neu, wenn eine andere Variante über Swatches gewählt wird"
ACHTUNG NUR SWATCHES - KEIN DROPDOWN
*/

$(document).ready(function() {
  if (window.location.href.includes("products")) {
    document.querySelectorAll('input, button').forEach(elem => {
      elem.addEventListener("click", event => {
        var item = event.target.value;
        var productURL = event.target.getAttribute('producturl');
        var productURLID = productURL;
        var parent = event;
        var clickedButtonUrl = this.baseURI;
        console.log('Variante gewechselt');
        setTimeout(function() {
          $('#reload').load(" #reload");
        }, 50);
      });
    });
  }
});

